import { Box, Stack, styled } from '@mui/material'
import DelDocDialog from 'components/AppDialogs/DelDocDialog'
import HomeUploadBox from 'components/ListPage/HomeUploadBox'
import ControlArea from 'components/ListPage/TasksControlArea'
import FullHeightFlexContainer from 'components/ui/FullHeightFlexContainer'
import Tab from 'components/ui/Tabs/Tab'
import Tabs from 'components/ui/Tabs/Tabs'
import UploadDialogContainer from 'components/UploadDialog/UploadDialogContainer'
import { MODE } from 'config'
import { useEffect, useState } from 'react'
import { useSearchParams, useNavigate } from 'react-router-dom'

import DocumentsList from './ListPage/DocumentsList'
import ReaderHelpIcon from './ReaderHelpIcon'
import { useVerifyHomeBaseLoaderData, useVerifyHomeLoaderData } from './VerifyHome.loader'

const LABELS = [
  'all(internal)',
  'チェック待ち',
  'チェック中',
  '確認依頼済み',
  '確認待ち',
  '出力待ち',
  '出力済み',
  'すべて',
  '未完了',
] as const

const MyTabs = styled(Tabs)({
  borderBottom: '0px solid #e8e8e8',
})

const MyTab = styled(Tab)({
  minWidth: 110,
  fontSize: '0.9rem',
})

export function VerifyHomeIndexRedirect() {
  const baseLoaderData = useVerifyHomeBaseLoaderData()
  const navigate = useNavigate()
  useEffect(() => {
    navigate(String(baseLoaderData.baseData[0].type), { replace: true })
  }, [navigate, baseLoaderData])
  return null
}

export default function VerifyHome() {
  const [selectedIDs, setSelectedIDs] = useState<string[]>([])
  const [openDelDialog, setOpenDelDialog] = useState(false)
  const [openUploadDialog, setOpenUploadDialog] = useState(false)
  const [_searchParams, setSearchParams] = useSearchParams()
  const navigate = useNavigate()

  const { baseData } = useVerifyHomeBaseLoaderData()
  const {
    data: { docInfoList: documents, total },
    page,
    perPage,
    type,
  } = useVerifyHomeLoaderData()

  useEffect(() => {
    setSelectedIDs(
      (sIDs) => documents?.map((d) => d.objectID).filter((id) => sIDs.includes(id)) || [],
    )
  }, [documents])

  const onTabsChange = (_e, value) => {
    navigate(`../${String(value)}`)
  }
  const tabLinks = baseData.map(({ type: status, total }) => (
    <MyTab key={status} label={`${LABELS[status]}(${total})`} value={status} />
  ))

  return (
    <FullHeightFlexContainer>
      <Stack direction="row" alignItems="center">
        <h2>ベリファイタスク一覧</h2>
        <ReaderHelpIcon
          builderPath={'/builder/ja-JP/ocr-reader-doc/verify-data.html'}
          concurPath={'/concur/ja-JP/ocr-reader-doc/verify-data.html'}
          invoicePath={'/invoice/ja-JP/ocr-reader-doc/verify-data.html'}
          orderFormPath={''}
        />
      </Stack>
      <ControlArea
        documents={documents}
        selectedIDs={selectedIDs}
        setOpenDelDialog={setOpenDelDialog}
        setOpenUploadDialog={setOpenUploadDialog}
      />

      {/* scrollbarが表示されなくなりやすいので編集に要注意 */}
      <Box display="flex" flexWrap="nowrap" overflow="hidden">
        <Box flexGrow={4} minWidth={0} display="flex" flexDirection="column">
          <Box>
            <MyTabs
              indicatorColor="primary"
              value={type}
              onChange={onTabsChange}
              data-testid="documents-list-status-tab"
            >
              {tabLinks}
            </MyTabs>
          </Box>
          <Box overflow="hidden">
            <DocumentsList
              selectedIDs={selectedIDs}
              setSelectedIDs={setSelectedIDs}
              documents={documents}
              total={total}
              page={page}
              perPage={perPage}
            />
          </Box>
        </Box>
        <Box pl={2} minWidth={200} maxWidth={280} flexGrow={1}>
          <HomeUploadBox setOpen={setOpenUploadDialog} />
        </Box>
      </Box>
      <UploadDialogContainer
        mode={MODE.VERIFY}
        open={openUploadDialog}
        setOpen={setOpenUploadDialog}
      />
      {documents && (
        <>
          <DelDocDialog
            open={openDelDialog}
            setOpenDialog={setOpenDelDialog}
            selectedIDs={selectedIDs}
            documents={documents}
            reloadDocs={(ids: string[]) => ids.length > 0 && setSearchParams((s) => s)}
          />
        </>
      )}
    </FullHeightFlexContainer>
  )
}
